import { Dispatch } from 'redux';
import { AxiosResponse } from 'axios';
import { DispatchFunction, IAgentDetail, IActiveFilter } from '@app/models';
import { GET_ALL_SYNC, SET_SYNC_COUNT, GET_SYNC_AGENT, GET_SYNC_AGENT_ATTRIBUTE_MAP, GET_SYNC_AGENT_OU_NODE } from '@app/store/constants';
import { syncService } from '@app/services';
import { loadingData } from '@app/store/actions';
import { store } from '@app/helpers';

export function handleGetSyncData(orderBy: string, asc: string, top: number, skip: number, organizationId: string, isReset: boolean, filters?: IActiveFilter[]): DispatchFunction {
    return ((dispatch: Dispatch) => {
        if (isReset) {
            dispatch(loadingData(true));
            dispatch(setSyncCount(0));
            dispatch(getAllSync([]));
        }
        syncService.getSyncs(orderBy, asc, top, skip, organizationId, filters)
            .then((response: AxiosResponse) => {
                const prevCount: number = store.getState().syncs.count;
                const count: number = response.data['@odata.count'];
                if (prevCount !== count) { dispatch(setSyncCount(count)); }

                dispatch(getAllSync(response.data.value));

                if (isReset) {
                    dispatch(loadingData(false));
                }
            })
            .catch(() => {
                dispatch(loadingData(false))
            });
    });
}

export function handleGetSyncAgentData(syncAgentId: string) {
    return ((dispatch: Dispatch) => {
        dispatch(loadingData(true));
        syncService.getSyncAgent(syncAgentId)
            .then((response: AxiosResponse) => {
                dispatch(getSyncAgent(response.data));
            })
            .then(() => dispatch(loadingData(false)));
    });
}

export function handleGetSyncAgentAttributeMapData(syncAgentId: string) {
    return ((dispatch: Dispatch) => {
        syncService.getSyncAgentAttributeMap(syncAgentId)
            .then((response: AxiosResponse) => {
                dispatch(getSyncAgentAttributeMap(response.data));
            });
    });
}

export function handleGetSyncAgentOUNodeData(syncAgentId: string) {
    return ((dispatch: Dispatch) => {
        syncService.getSyncAgentOUNode(syncAgentId)
            .then((response: AxiosResponse) => {
                dispatch(getSyncAgentOUNode(response.data));
            });
    });
}

export function getAllSync(syncs: IAgentDetail[]) {
    return {
        payload: syncs,
        type: GET_ALL_SYNC
    };
}

export function setSyncCount(count: number) {
    return {
        payload: count,
        type: SET_SYNC_COUNT
    };
}

export function getSyncAgent(syncAgent: any) {
    return {
        payload: syncAgent,
        type: GET_SYNC_AGENT
    };
}

export function getSyncAgentAttributeMap(syncAgentAttributeMap: any) {
    return {
        payload: syncAgentAttributeMap,
        type: GET_SYNC_AGENT_ATTRIBUTE_MAP
    };
}

export function getSyncAgentOUNode(syncAgentOUNode: any) {
    return {
        payload: syncAgentOUNode,
        type: GET_SYNC_AGENT_OU_NODE
    };
}

